import alasql from "alasql";
const HALF_HOUR = 0, HOUR = 1, SHIFT = 2, DAY = 3, WEEK = 4, MONTH = 5, YEAR = 6;
const week_names = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
const month_names = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
let zoom1 = DAY;

const normalize = [
    null,
    function (date) { date.setMinutes(0); },
    function (date) { date.setMinutes(0); },
    function (date) { date.setHours(0); },
    function (date) { date.setHours(0); },
    function (date) { date.setDate(1); },
    function (date) { date.setMonth(0); },
]


const reference = new Date();
let dragged = null;

let data_inizio = new Date();

// Funzione per aggiornare il task dopo il drop nell?indexedDB
async function updateDB(ris, id_task, id_target, durata) {

    id_target = id_target * 1 - 1;
    console.log("Id_task" + id_task);
    let task_list = [];

    await new Promise((resolve) => {
        alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        SELECT * FROM commessa_db.Task WHERE id_task = ${id_task}`, [], function (res) {
            task_list.push(res[1][0]);
            resolve();
        });
    });

    console.log("Task spostato: ", task_list);
    console.log(task_list[0].data_inizio);
    let data_inizio_prec = new Date(task_list[0].data_inizio);
    console.log("Data inizio prec:", data_inizio_prec);
    let data_fine_prec = new Date(task_list[0].data_fine);
    console.log("Data fine prec:", data_fine_prec);

    let data_temp = new Date();
    data_temp.setTime(data_inizio);
    let data_nuova = data_temp;
    //console.log("data nuova inizio " + data_nuova);
    let data_nuova_fine = new Date();
    let valore_nuovo = null;
    let valore_nuovo_ore = null;
    let valore_nuovo_giorno = null;
    let giorno_fine = null;

    switch (zoom1) {
        case HALF_HOUR: // Da sistemare
            data_nuova.setMinutes(data_inizio.getMinutes() + id_target * 1);
            data_nuova_fine.setMinutes(data_nuova.getMinutes() + durata);
            break;
        case HOUR:
            valore_nuovo_ore = data_inizio.getHours() * 1 + id_target * 1 + 1;
            data_nuova.setHours(valore_nuovo_ore);
            valore_nuovo_giorno = data_nuova.getDate() * 1 + (durata / 24);
            data_nuova_fine.setHours(valore_nuovo_ore + Math.ceil(durata * 1));
            data_nuova_fine.setDate(valore_nuovo_giorno);
            if (data_nuova_fine.getDate() > 31) { data_nuova_fine.setMonth(data_nuova.getMonth() * 1 + 1); }
            else { data_nuova_fine.setMonth(data_nuova.getMonth()); }
            break;
        case SHIFT:
            valore_nuovo_ore = data_inizio.getHours() * 1 + id_target * 8;
            data_nuova.setHours(valore_nuovo_ore);
            valore_nuovo_giorno = data_nuova.getDate() * 1 + (durata / 3);
            console.log("nuovo giorno" + valore_nuovo_giorno);
            data_nuova_fine.setHours(valore_nuovo_ore + durata * 8);
            data_nuova_fine.setDate(valore_nuovo_giorno);
            data_nuova_fine.setMonth(data_nuova.getMonth());
            data_nuova_fine.setMinutes(data_fine_prec.getMinutes());
            data_nuova_fine.setSeconds('00');
            break;
        case DAY:
            valore_nuovo = data_inizio.getDate() * 1 + id_target * 1;
            data_nuova.setDate(valore_nuovo);
            data_nuova.setHours(data_inizio_prec.getHours());
            data_nuova.setMinutes(data_inizio_prec.getMinutes());
            console.log("Data nuova: ", data_nuova);
            giorno_fine = (data_nuova.getDate() * 1 + durata * 1);
            data_nuova_fine.setHours(data_fine_prec.getHours());
            data_nuova_fine.setMonth(data_nuova.getMonth());
            data_nuova_fine.setDate(giorno_fine);
            data_nuova_fine.setMinutes(data_fine_prec.getMinutes());
            data_nuova_fine.setSeconds('00');
            if (data_nuova_fine.getDate() < durata) { data_nuova_fine.setMonth(data_nuova.getMonth() + 1); }
            else if (valore_nuovo > 31) { data_nuova_fine.setMonth(data_nuova.getMonth()); }
            else { data_nuova_fine.setMonth(data_nuova.getMonth()); }
            break;
        case WEEK: //Da sistemare
            data_nuova.setDate(data_inizio.getDate() + id_target);
            while (data_inizio.getDay() != 1) { data_inizio.setDate(data_inizio.getDate() + id_target); } //Inizio settimana al lunedì
            data_nuova_fine.setDate(data_nuova.getDate() + durata);
            while (data_nuova.getDay() != 1) { data_nuova_fine.setDate(data_nuova_fine.getDate() - 1); }
            break;
        case MONTH: //Da sistemare
            data_nuova.setMonth(data_inizio.getMonth() + id_target);
            data_nuova_fine.setMonth(data_nuova.getMonth() + durata);
            break;
        case YEAR: //Da sistemare
            data_nuova.setFullYear(data_inizio.getFullYear() + id_target);
            data_nuova_fine.setFullYear(data_nuova.getFullYear() + durata);
            break;

    }
    //Format delle date per caricarle sull'indexedDB
    var datestring1 = `${data_nuova.getFullYear()}-${(data_nuova.getMonth() + 1).toString().padStart(2, "0")}-${data_nuova.getDate().toString().padStart(2, "0")}T${data_nuova.getHours().toString().padStart(2, "0")}:${data_nuova.getMinutes().toString().padStart(2, "0")}:${data_nuova.getSeconds().toString().padStart(2, "0")}`;
    var datestring2 = `${data_nuova_fine.getFullYear()}-${(data_nuova_fine.getMonth() + 1).toString().padStart(2, "0")}-${data_nuova_fine.getDate().toString().padStart(2, "0")}T${data_nuova_fine.getHours().toString().padStart(2, "0")}:${data_nuova_fine.getMinutes().toString().padStart(2, "0")}:${data_nuova_fine.getSeconds().toString().padStart(2, "0")}`;

    console.log("data fine dopo " + data_nuova_fine);

    alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.Task SET id_attivita = ${ris}, data_inizio = "${datestring1}", data_fine = "${datestring2}", modificato = 1 WHERE id_task = ${id_task}`, [], function () {
    });
}
// Funzione per gestire il drop di un task dopo il drag
function ondrop(e) {

    //Controllo che la cella di arrivo sia valida

    let cursorX = '';
    let cursorY = '';
    cursorX = e.pageX;
    cursorY = e.pageY;
    let lunghezza = dragged.getAttribute('lunghezza');
    let elements = document.elementsFromPoint(cursorX, cursorY);
    let elements_prim_meta = document.elementsFromPoint(cursorX * 1 + 20 * lunghezza, cursorY);
    let elements_meta = document.elementsFromPoint(cursorX * 1 + 30 * lunghezza, cursorY);
    let elements_sec_meta = document.elementsFromPoint(cursorX * 1 + 40 * lunghezza, cursorY);
    let elements_fine = document.elementsFromPoint(cursorX * 1 + 60 * lunghezza, cursorY);
    let result = 2;
    /* console.log("elementi ");
    console.log(elements); */
    for (let i = 0; i < elements.length; i++) { // Ciclo tutti i tag individuati nel punto di drop per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements[i]);
        if (elemento.getAttribute('data-itemtype') || e.target.tagName.toLowerCase() === 'span') {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;

            } else if (e.target.tagName.toLowerCase() !== 'td' && elemento.getAttribute('id_task') == dragged.getAttribute('id_task')) {
                result = 3;
            }
        }
    }

    for (let i = 0; i < elements_prim_meta.length; i++) { // Ciclo tutti i tag individuati prima della metà per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements_prim_meta[i]);
        if (elemento.getAttribute('data-itemtype')) {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    for (let i = 0; i < elements_meta.length; i++) { // Ciclo tutti i tag individuati nel punto a metà per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements_meta[i]);
        if (elemento.getAttribute('data-itemtype')) {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    for (let i = 0; i < elements_sec_meta.length; i++) { // Ciclo tutti i tag individuati poco dopo la metà per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements_sec_meta[i]);
        if (elemento.getAttribute('data-itemtype')) {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    for (let i = 0; i < elements_fine.length; i++) { // Come sopra ma controllo che non ci sia nulla nella cella finale del td dragged
        const elemento = (elements_fine[i]);
        if (elemento.getAttribute('data-itemtype')) {

            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }
    console.log("result" + result);
    // Cella target vuota
    if (result == 2) {

        e.preventDefault();
        let row_dragged = dragged.parentNode;

        const cella_sostitutiva = document.createElement('td');
        cella_sostitutiva.id = dragged.id;
        cella_sostitutiva.setAttribute('attivita', dragged.getAttribute("attivita"));
        cella_sostitutiva.addEventListener('drop', function (e) {
            ondrop(e);
            e.preventDefault()
        });
        cella_sostitutiva.addEventListener('dragover', function (e) {
            e.preventDefault()
        }, false);
        cella_sostitutiva.addEventListener('dragleave', function (e) {
            e.preventDefault()
        }, false);

        // Modifico i campi del task
        //let row_id = e.target.parentNode.id;
        let id_task = dragged.getAttribute("id_task");
        let attivita = e.target.getAttribute("attivita");
        dragged.setAttribute('attivita', attivita);
        let riga = e.target.parentNode.getAttribute("riga");
        console.log("id_task prima di spostamento" + id_task);
        console.log("ris prima di spost" + attivita);
        let durata = dragged.getAttribute("durata");
        let id = e.target.id;
        // Ciclo per individuale elemento del database da cambiare
        updateDB(attivita, id_task, id, durata, riga);


        // Sposto il task

        dragged.id = id;
        e.preventDefault();
        dragged.parentNode.replaceChild(cella_sostitutiva, dragged);
        e.target.parentNode.replaceChild(dragged, e.target);

        // Rimuovo la riga se è rimasta vuota
        let rimasto = row_dragged.querySelectorAll("[data-itemtype = '0']");
        let rimasto_vinc = row_dragged.querySelectorAll("[data-itemtype = '2']");
        let rimasto_risorsa = row_dragged.querySelectorAll("[data-itemtype = '1']");
        if (rimasto[0] == undefined && rimasto_vinc[0] == undefined && rimasto_risorsa[0] == undefined) {
            row_dragged.remove();
        }


    } else if (result == 0) {  // Cella target occupata con span


        let row_dragged = dragged.parentNode;
        let row_target = e.target.parentNode;
        let id = e.target.id;

        const cella_sostitutiva = document.createElement('td');
        cella_sostitutiva.id = dragged.id;
        cella_sostitutiva.setAttribute('attivita', dragged.getAttribute("attivita"));
        cella_sostitutiva.addEventListener('drop', function (e) {
            ondrop(e);
            e.preventDefault()
        });
        cella_sostitutiva.addEventListener('dragover', function (e) {
            e.preventDefault()
        }, false);
        cella_sostitutiva.addEventListener('dragleave', function (e) {
            e.preventDefault()
        }, false);

        dragged.id = id;
        dragged.setAttribute('attivita', attivita);
        const new_row = document.createElement('tr');
        const risorsa_cell = document.createElement('td');
        risorsa_cell.innerHTML = "ciao";
        risorsa_cell.style.height = "100%";
        new_row.appendChild(risorsa_cell);

        //Da sistemare numero td nuove righe
        for (let i = 1; i <= 50; i++) {
            const startcell = document.createElement('td');
            startcell.id = i;
            startcell.setAttribute('attivita', e.target.getAttribute("attivita"));
            startcell.addEventListener('dragover', function (e) {
                e.preventDefault()
            }, false);
            startcell.addEventListener('dragleave', function (e) {
                e.preventDefault()
            }, false);
            startcell.addEventListener('drop', ondrop);
            new_row.appendChild(startcell);
        }

        // Modifico i campi del task
        //let row_id = row_target.id;

        let attivita = e.target.getAttribute("attivita");
        let riga = e.target.parentNode.getAttribute("riga");
        let id_task = dragged.getAttribute("id_task");
        console.log("id_task prima di spostamento" + id_task);
        let durata = dragged.getAttribute("durata");
        // Ciclo per individuale elemento del database da cambiare
        updateDB(attivita, id_task, id, durata, riga * 1 + 1);

        new_row.id = row_target.id + 1;

        row_target.parentNode.insertBefore(new_row, row_target.nextSibling);
        const new_target = document.getElementById(new_row.id).getElementsByTagName('td')[dragged.id];
        dragged.parentNode.replaceChild(cella_sostitutiva, dragged);
        new_target.parentNode.replaceChild(dragged, new_target);

        // Rimuovo la riga se è rimasta vuota
        let rimasto = row_dragged.querySelectorAll("[data-itemtype = '0']");
        let rimasto_vinc = row_dragged.querySelectorAll("[data-itemtype = '2']");
        let rimasto_risorsa = row_dragged.querySelectorAll("[data-itemtype = '1']");

        if (rimasto[0] == undefined && rimasto_vinc[0] == undefined && rimasto_risorsa[0] == undefined) {
            row_dragged.remove();
        }


    } else if (result == 1) { // Cella target occupata ma sempre td
        // span è target
        let span_target = null;

        if (e.target.tagName.toLowerCase() === 'b') {
            span_target = e.target.parentNode;
        } else {
            span_target = e.target;
        }

        let row_dragged = dragged.parentNode;
        let div_target = span_target.parentNode;
        let fig_target = div_target.parentNode;
        let td_target = fig_target.parentNode;
        let row_target = td_target.parentNode;
        let id = td_target.id;
        //console.log(td_target);
        const cella_sostitutiva = document.createElement('td');
        cella_sostitutiva.id = dragged.id;
        cella_sostitutiva.setAttribute('attivita', dragged.getAttribute("attivita"));
        cella_sostitutiva.addEventListener('drop', function (e) {
            ondrop(e);
            e.preventDefault()
        });
        cella_sostitutiva.addEventListener('dragover', function (e) {
            e.preventDefault()
        }, false);
        cella_sostitutiva.addEventListener('dragleave', function (e) {
            e.preventDefault()
        }, false);


        dragged.id = id;
        dragged.setAttribute('attivita', attivita);

        const new_row = document.createElement('tr');
        const risorsa_cell = document.createElement('td');
        risorsa_cell.innerHTML = "ciao";
        risorsa_cell.style.height = "100%";
        new_row.appendChild(risorsa_cell);

        //Da sistemare numero td nuove righe
        for (let i = 1; i <= 50; i++) {
            const startcell = document.createElement('td');
            startcell.id = i;
            startcell.setAttribute('attivita', td_target.getAttribute("attivita"));
            startcell.addEventListener('dragover', function (e) {
                e.preventDefault()
            }, false);
            startcell.addEventListener('dragleave', function (e) {
                e.preventDefault()
            }, false);
            startcell.addEventListener('drop', ondrop);
            new_row.appendChild(startcell);
        }

        // Modifico i campi del task
        //let row_id = row_target.id;

        let attivita = td_target.getAttribute("attivita");
        let id_task = dragged.getAttribute("id_task");
        let riga = e.target.parentNode.getAttribute("riga");
        console.log("id_task prima di spostamento" + id_task);
        let durata = dragged.getAttribute("durata");
        updateDB(attivita, id_task, id, durata, riga * 1 + 1);

        new_row.id = row_target.id + 1;

        row_target.parentNode.insertBefore(new_row, row_target.nextSibling);
        const new_target = document.getElementById(new_row.id).getElementsByTagName('td')[dragged.id];
        dragged.parentNode.replaceChild(cella_sostitutiva, dragged);
        new_target.parentNode.replaceChild(dragged, new_target);

        // Rimuovo la riga se è rimasta vuota
        let rimasto = row_dragged.querySelectorAll("[data-itemtype = '0']");
        let rimasto_vinc = row_dragged.querySelectorAll("[data-itemtype = '2']");
        let rimasto_risorsa = row_dragged.querySelectorAll("[data-itemtype = '1']");
        if (rimasto[0] == undefined && rimasto_vinc[0] == undefined && rimasto_risorsa[0] == undefined) {
            row_dragged.remove();
        }
    }
}

class CalendarG {
    zoom_levels = ['Mezz\'ore', 'Ore', 'Turni', 'Giorni', 'Settimane', 'Mesi', 'Anni'];
    blocks = new Array();
    risorse = new Array();
    zoom = DAY;
    task_modificati = new Array();
    db_connection = null;
    version_db = 5;

    constructor() { this.setStep(); }

    //-------------------------Creazione e aggiornamento IndexedDB
    gestore_db(attivita, tasks, risorse) {
        const that = this;

        if (attivita != undefined && tasks != undefined && risorse != undefined) {
            const dbName = "commessa_db";
            const obStoreAtt = "Attivita";
            const obStoreTask = "Task";
            const obStoreRis = "Risorse";


            var request = indexedDB.open(dbName, this.version_db);
            request.onerror = function (event) {
                console.log("errore apertura DB" + event);
            }

            request.onsuccess = function (res) {
                that.db_connection = res.target.result;
                console.log("db_connection: ", that.db_connection);
            }
            request.onupgradeneeded = function (event) {
                var db = event.target.result;
                let objectStoreAtt = db.createObjectStore(obStoreAtt, { keyPath: "id_attivita" });
                let objectStoreTask = db.createObjectStore(obStoreTask, { keyPath: "id_task" });
                let objectStoreRis = db.createObjectStore(obStoreRis, { keyPath: "id_risorsa" });

                objectStoreAtt.transaction.oncomplete = function () {

                };
                objectStoreTask.transaction.oncomplete = function () {

                };

                objectStoreRis.transaction.oncomplete = function () {
                    // Aggiungo i valori all'objectStore.
                    var attivitaObjectStore = db.transaction(obStoreAtt, "readwrite").objectStore(obStoreAtt);
                    var tasksObjectStore = db.transaction(obStoreTask, "readwrite").objectStore(obStoreTask);
                    var risObjectStore = db.transaction(obStoreRis, "readwrite").objectStore(obStoreRis);

                    for (let k = 0; k < attivita.length; k++) {
                        let attivita1 = attivita[k];
                        attivitaObjectStore.add(attivita1);
                    }

                    for (let j = 0; j < tasks.length; j++) {
                        let task = tasks[j];
                        tasksObjectStore.add(task);
                    }

                    for (let i = 0; i < risorse.length; i++) {
                        let risorsa1 = risorse[i];
                        risObjectStore.put(risorsa1);
                    }
                };
            };
        }


    }

    // Azzeramento minuti, secondi ecc
    normalizeCalendar(date) {

        date.setSeconds(0);
        date.setMilliseconds(0);

        try {
            for (let j = this.zoom; j >= 0; j--) {
                const norm_func = normalize[j];
                if (norm_func == null) { continue; }
                norm_func(date);
            }
        } catch (error) {
            window.error = error;
        }
    }

    //-------------------------Costruzione del calendario e inserimento task
    async build(attivita, tasks, risorse) {


        let att_length = attivita.length;
        let task_length = tasks.length;
        //let ris_length = risorse.length;


        for (let j = 0; j < task_length; j++) {
            tasks[j].riga = 0;

        }

        // Carico i dati dall'IndexedDb se sono presenti
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.Attivita`, [], function (res) {
                for (let i = 0; i < res[1].length; i++) {
                    attivita[i] = res[1][i];
                }
                resolve();
            });
        });

        // Cerco data inizio e fine tra le date delle attività

        let date_list_inizio = new Array();
        let date_list_fine = new Array();
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        SELECT * FROM commessa_db.Attivita ORDER BY dataInizio`, [], function (res) {
                for (let i = 0; i < res[1].length; i++) {
                    let dataInizio = new Date();
                    dataInizio = res[1][i].dataInizio;
                    date_list_inizio.push(dataInizio);

                }
                resolve();
            });
        });

        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        SELECT * FROM commessa_db.Attivita ORDER BY dataFine`, [], function (res) {
                for (let i = 0; i < res[1].length; i++) {

                    let dataFine = new Date();
                    dataFine = res[1][i].dataFine;
                    date_list_fine.push(dataFine);
                }
                resolve();
            });
        });

        /* for (let at = 0; at < attivita.length; at++) {
            let dataInizio = new Date();
            let dataFine = new Date();
            dataInizio = attivita[at].dataInizio;
            dataFine = attivita[at].dataFine;
            date_list_inizio.push(dataInizio);
            date_list_fine.push(dataFine);
        } */

        let start_date = new Date(date_list_inizio[0]);
        let end_date = new Date(date_list_fine[date_list_fine.length * 1 - 1]);

        start_date.setDate(start_date.getDate() * 1 - 2);
        end_date.setDate(end_date.getDate() * 1 + 2);

        let data_temp = new Date();
        data_temp.setTime(start_date);
        data_inizio = data_temp;

        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.Task`, [], function (res) {
                for (let i = 0; i < res[1].length; i++) {
                    tasks[i] = res[1][i];
                }
                resolve();
            });
        });

        alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        UPDATE commessa_db.Task SET riga = 0`, [], function () {
        });

        /*       alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
              UPDATE commessa_db.Task SET modificato = 0`, [], function () {
              }); */

        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.Risorse`, [], function (res) {
                for (let i = 0; i < res[1].length; i++) {
                    risorse[i] = res[1][i];
                }
                resolve();
            });
        });

        //---------------------- CREAZIONE CALENDARIO
        reference.setTime(start_date.getTime());
        this.normalizeCalendar(reference);
        switch (this.zoom) {
            case HALF_HOUR:
                reference.setMinutes(reference.getMinutes() + 30);
                break;
            case HOUR:
                reference.setHours(reference.getHours() + 1);
                break;
            case SHIFT:
                reference.setHours(reference.getHours());
                break;
            case DAY:
                reference.setDate(reference.getDate());
                break;
            case WEEK:
                reference.setDate(reference.getDate());
                while (reference.getDay() != 1) { reference.setDate(reference.getDate() - 1); } //Inizio settimana al lunedì
                break;
            case MONTH:
                reference.setMonth(reference.getMonth());
                break;
            case YEAR:
                reference.setFullYear(reference.getFullYear());
                break;
        }

        const stepDate = this.getFormatter(reference);
        const fragments = { upper: new DocumentFragment(), lower: new DocumentFragment() };
        const last_upperblock = { reference: null, colspan: 1, value: null };
        this.blocks = new Array();
        const target = new Date(end_date.getTime());
        target.step(2);

        do {
            this.blocks.push(reference.getTime());
            const values = stepDate();
            const block = document.createElement('th');
            block.innerText = values.lower;
            fragments.lower.appendChild(block);

            if (values.upper != last_upperblock.value) {
                last_upperblock.value = values.upper;
                last_upperblock.colspan = 1;
                last_upperblock.reference = document.createElement('th');
                last_upperblock.reference.innerText = values.upper;
                fragments.upper.appendChild(last_upperblock.reference);
            } else {
                last_upperblock.colspan++;
                last_upperblock.reference.setAttribute('colspan', last_upperblock.colspan);
            }
        } while (reference <= target);

        requestAnimationFrame(function () {
            const header = document.getElementById('diagram_table').getElementsByTagName('thead')[0];
            const headers = {
                upper: header.children[0],
                lower: header.children[1]
            };
            var prima_col = document.createElement('th');
            prima_col.innerHTML = 'Attività';
            headers.upper.innerHTML = '';
            headers.lower.innerHTML = '';
            prima_col.setAttribute("class", "col_attivita");
            prima_col.setAttribute('data-itemtype', 1);
            var prima_col_su = document.createElement('th');


            headers.upper.appendChild(prima_col_su);
            headers.upper.appendChild(fragments.upper);
            headers.lower.appendChild(prima_col);
            headers.lower.appendChild(fragments.lower);


        });

        const body = document.getElementById('diagram_table').getElementsByTagName('tbody')[0];
        body.innerHTML = '';


        // Creo le righe con nome id quello della macchina
        for (let t = 0; t < att_length; t++) {
            const total_row_diagram = document.createElement('tr');
            total_row_diagram.setAttribute('riga', 0);
            total_row_diagram.id = "Attività " + attivita[t].id_attivita + 0;
            const risorsa_cell = document.createElement('td');
            risorsa_cell.innerHTML = attivita[t].des_attivita;
            risorsa_cell.setAttribute('data-itemtype', 1);
            risorsa_cell.setAttribute('class', "col_attivita");
            total_row_diagram.appendChild(risorsa_cell);

            // Creo i td della riga

            for (let i = 1; i <= this.blocks.length; i++) {
                const startcell = document.createElement('td');
                startcell.id = i;
                startcell.setAttribute('attivita', attivita[t].id_attivita);
                startcell.addEventListener('dragover', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('dragleave', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('drop', ondrop);

                total_row_diagram.appendChild(startcell);
            }

            body.appendChild(total_row_diagram);


            /* Faccio valorizzare l'array dei task da Alasql;
               * uso una Promise per aspettare che Alasql abbia
               * finito questa attività prima di procedere oltre
               * con la logica. */

            // Salvo tutte le task di una macchina
            let task_macchina = new Array();
            await new Promise((resolve) => {
                alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.Task WHERE id_attivita = ${attivita[t].id_attivita} ORDER BY data_inizio`, [], function (res) {
                    for (let i = 0; i < res[1].length; i++) {
                        task_macchina[i] = res[1][i];
                    }
                    resolve();
                });
            });

            let sovrapposizioni = 0;
            let sovrapp_tot = 0;
     
            for (let t1 = 0; t1 < task_macchina.length; t1++) {

                //console.log("Id t1: " + task_macchina[t1].id_task + " Riga t1: " + task_macchina[t1].riga);

                for (let t2 = t1 + 1; t2 < task_macchina.length; t2++) {
                    if (t1 != t2) {
                        //console.log("Sovrapposti?");
                        //console.log(this.ifSovrapposto(task_macchina, t1, t2));
                        if (this.ifSovrapposto(task_macchina, t1, t2)) {
                            sovrapposizioni = 0;
                            if (task_macchina[t2].riga == task_macchina[t1].riga) {
                                task_macchina[t2].riga = task_macchina[t1].riga + 1;
                                await new Promise((resolve) => {
                                    sovrapposizioni++;
                                    alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
                                            UPDATE commessa_db.Task SET riga = ${task_macchina[t2].riga} WHERE id_task = ${task_macchina[t2].id_task}`, [], function () {
                                        for (let z = 0; z < tasks.length; z++) {
                                            if (tasks[z].id_task == task_macchina[t2].id_task) {
                                                tasks[z].riga = task_macchina[t2].riga;
                                            }
                                        }
                                        // console.log(`${task_macchina[t2].riga} per task ${task_macchina[t2].id_task}.`);
                                        resolve();
                                    });
                                });
                            }

                            if (sovrapposizioni > sovrapp_tot) {
                                sovrapp_tot = sovrapposizioni;
                            }
                        }
                        //console.log("Id t2: " + task_macchina[t2].id_task + " Riga t2: " + task_macchina[t2].riga);
                    }
                }
            }


            let righe_agg = sovrapp_tot;
           

            // Creo righe in più

            for (let l = 1; l <= righe_agg; l++) {
                const righe = document.createElement('tr');
                righe.id = "Attività " + attivita[t].id_attivita + l;

                righe.setAttribute('class', "col_risorse");
                righe.setAttribute('riga', l);

                for (let i = 0; i <= this.blocks.length; i++) {
                    const startcell = document.createElement('td');
                    startcell.setAttribute('attivita', attivita[t].id_attivita);
                    startcell.id = i;
                    startcell.addEventListener('dragover', function (e) {
                        e.preventDefault()
                    }, false);
                    startcell.addEventListener('dragleave', function (e) {
                        e.preventDefault()
                    }, false);
                    startcell.addEventListener('drop', ondrop);

                    righe.appendChild(startcell);
                }

                body.appendChild(righe);
            }

        }



        //Stabilisce l'unità di misura della differenza di tempo nel context menu
        for (let i = 0; i < tasks.length; i++) {
            let misura = "";
            let conversione = "";
            switch (this.zoom) {
                case HALF_HOUR:
                    misura = "mezz'ore";
                    conversione = 1 / 2;
                    break;
                case HOUR:
                    misura = "ore";
                    conversione = 1;
                    break;
                case DAY:
                    misura = "giorni";
                    conversione = 24 * 1;
                    break;
                case WEEK:
                    misura = "settimane";
                    conversione = 168 * 1;
                    break;
                case SHIFT:
                    misura = "turni";
                    conversione = 8 * 1;
                    break;
                case MONTH:
                    misura = "mesi";
                    conversione = 720 * 1;
                    break;
                case YEAR:
                    misura = "anni";
                    conversione = 8640 * 1;
                    break;
            }



            //Creazione e inserimento task

            let data_task = new Date(tasks[i].data_inizio);
            let data_fine = new Date(tasks[i].data_fine);
            let pos_ini = Math.ceil(this.stepNumber(start_date, data_task) + 1);
            let completamento = tasks[i].percentuale * 100;

            let risorse_task = new Array();
            let competenze_task = new Array();

            for (let r = 0; r < risorse.length; r++) {
                if (risorse[r].id_task == tasks[i].id_task) {
                    if (!risorse_task.includes(risorse[r].des_risorsa.cognome)) {
                        risorse_task.push(risorse[r].des_risorsa.cognome);
                    }
                    if (!competenze_task.includes(risorse[r].des_risorsa.competenza)) {
                        competenze_task.push(risorse[r].des_risorsa.competenza);
                    }
                }
            }

            // Formattazione degli array per il context menu
            let text_op = risorse_task.toString();
            let oper_format = text_op.replace(/,/g, ', ');

            let text_comp = competenze_task.toString();
            let comp_format = text_comp.replace(/,/g, ', ');

            //console.log("Id_task: " + tasks[i].id_task + "posizione: " + pos_ini);


            const target = document.getElementById("Attività " + tasks[i].id_attivita + tasks[i].riga).getElementsByTagName('td')[pos_ini];
            // cod_task == codice articolo prodotto
            //des_task == nome fase
            target.innerHTML = `
            
            <figure data-itemtype="4" id_task="${tasks[i].id_task}"
            >
            <div>
            <span><b>${tasks[i].cod_task}</b> - ${tasks[i].des_task}</span>
            <span id="completamento"></span>
            <aside id_task="${tasks[i].id_task}" data-type="0" ></aside>
            <aside id_task="${tasks[i].id_task}" data-type="1" ></aside>
            </div>                
            </figure>
            <nav class="context-menu-${i}">
            <h3>${tasks[i].cod_task} - ${tasks[i].des_task}</h5>
            <ul class="context-menu__items">
                <li class="context-menu__item">
                <b>Competenze</b>: ${comp_format}
                </li>
                <li class="context-menu__item">
                <b>Operatori assegnati</b>: ${oper_format}
                </li>
                <li class="context-menu__item">
                <b>Tempo</b>: ${Math.ceil(this.stepNumber(data_task, data_fine))} ${misura} / ${Math.ceil(this.stepNumber(data_task, data_fine) * conversione)} ore
                </li>
                <li class="context-menu__item">
                <b>Completamento</b>: ${completamento} %
                </li>
            </ul>
            </nav>
            `;

            target.style.setProperty('--duration', this.stepNumber(data_task, data_fine));
            target.setAttribute('durata', this.stepNumber(data_task, data_fine));
            target.setAttribute('attivita', tasks[i].id_attivita);
            target.setAttribute('lunghezza', this.stepNumber(data_task, data_fine));
            target.style.setProperty('--completamento', completamento);
            target.setAttribute('data-itemtype', 0);
            target.setAttribute('id_task', tasks[i].id_task);
            target.setAttribute('draggable', 'true');
            let activeClassName = "context-menu--active";
            let menuState = 0;
            let menu = document.querySelector(".context-menu-" + i);
            menu.style = "display: none; position: absolute; background: white; border: 1px solid black; z-index:3";


            //Aggiungo l'evento click sinistro per aprire il menu delle task
            target.addEventListener('contextmenu', function (e) {
                e.preventDefault();
                if (menuState == 0) {
                    menuState = 1;
                    menu.classList.add(activeClassName);

                }
                else if (menuState == 1) {
                    menuState = 0;
                    menu.classList.remove(activeClassName);
                }
            }, false);

            target.addEventListener('dragstart', function (e) {
                let target = e.target;
                dragged = target;
                e.dropEffect = 'move';
            });
        }

        for (let i = 0; i < 5; i++) {
            const total_row_diagram = document.createElement('tr');
            const risorsa_cell = document.createElement('td');
            risorsa_cell.innerHTML = "ciao";
            risorsa_cell.style.height = "100%";
            risorsa_cell.style.border = "none";
            total_row_diagram.appendChild(risorsa_cell);
            body.appendChild(total_row_diagram);
        }

    }


    getFormatter(date) {
        switch (this.zoom) {
            case HALF_HOUR: {
                return function () {
                    const value = {
                        upper: `${week_names[date.getDay()]} ${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${date.getHours()}:${date.getMinutes().toString().padStart(2, "0")}`

                    };
                    date.setMinutes(date.getMinutes() + 30);
                    return value;
                }
            }
            case HOUR: {
                return function () {
                    const value = {
                        upper: `${week_names[date.getDay()]} ${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${date.getHours()}:00`
                    };
                    date.setHours(date.getHours() + 1);
                    return value;
                }
            }
            case SHIFT: {
                return function () {
                    const temp_date = new Date(date.getTime());
                    temp_date.setHours(date.getHours() + 8);
                    const value = {
                        upper: `${week_names[date.getDay()]} ${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${date.getHours()} - ${temp_date.getHours()}`
                    };
                    date.setHours(date.getHours() + 8);
                    return value;
                }
            }
            case DAY: {
                return function () {
                    const value = {
                        upper: `${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${week_names[date.getDay()]} ${date.getDate()}`
                    };
                    date.setDate(date.getDate() + 1);
                    return value;
                }
            }
            case WEEK: {
                return function () {
                    const temp_date = new Date(date.getTime());
                    temp_date.setDate(date.getDate() + 6);
                    const value = {
                        upper: `${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${Math.ceil(date.getDate() / 7)}`
                    };
                    date.setDate(date.getDate() + 7);
                    return value;
                }
            }
            case MONTH: {
                return function () {
                    const value = {
                        upper: date.getFullYear(),
                        lower: `${month_names[date.getMonth()]}`
                    };
                    date.setMonth(date.getMonth() + 1);
                    return value;
                }
            }
            case YEAR: {
                return function () {
                    const value = {
                        upper: Math.floor(date.getFullYear() / 10) * 10,
                        lower: date.getFullYear()
                    };
                    date.setFullYear(date.getFullYear() + 1);
                    return value;
                }
            }

        }
    }

    setStep() {
        switch (this.zoom) {
            case HALF_HOUR:
                Date.prototype.step = function (diff) { this.setMinutes(this.getMinutes() + (diff * 30)); }
                break;
            case HOUR:
                Date.prototype.step = function (diff) { this.setHours(this.getHours() + diff); }
                break;
            case SHIFT:
                Date.prototype.step = function (diff) { this.setHours(this.getHours() + (diff * 8)); }
                break;
            case DAY:
                Date.prototype.step = function (diff) { this.setDate(this.getDate() + diff); }
                break;
            case WEEK:
                Date.prototype.step = function (diff) { this.setDate(this.getDate() + (diff * 7)); }
                break;
            case MONTH:
                Date.prototype.step = function (diff) { this.setMonth(this.getMonth() + diff); }
                break;
            case YEAR:
                Date.prototype.step = function (diff) { this.setFullYear(this.getFullYear() + diff); }
                break;
        }
    }

    unsetStep() { delete Date.prototype.step; }

    setZoom(zoomlevel) {
        this.zoom = zoomlevel;
        zoom1 = zoomlevel;
        this.setStep();
    }
    // Funzione che trasforma la differenza tra due date in differenza oraria e poi calcola gli step tra le date in base al passo
    stepNumber(data_inizio, data_fine) {
        let passi = 0;
        var diff = (data_fine.valueOf() - data_inizio.valueOf()) / (1000 * 3600); //Ore di differenza

        switch (this.zoom) {
            case 25: // Quarto d'ora
                passi = diff * 4;
                break;
            case HALF_HOUR: // Mezz'ora
                passi = diff * 2;
                break;
            case HOUR: // Ora
                passi = diff - 1;
                break;
            case DAY:
                passi = diff / 24;
                break;
            case WEEK:
                passi = diff / 168;
                break;
            case SHIFT:
                passi = diff / 8;
                break;
            case MONTH:
                passi = diff / 720;
                break;
            case YEAR:
                passi = diff / 8640;
                break;
        }
        return passi;
    }

    ifSovrapposto(task_macchina, t1, t2) {

        let sovrapposti = false;

        /* let data_fine1 = task_macchina[t1].data_fine;
        let data_inizio2 = task_macchina[t2].data_inizio;
        let data_fine2 = task_macchina[t2].data_fine; */

        //Calcolo settimana dell'anno
        let currentdate1 = new Date(Date.parse(task_macchina[t1].data_inizio));
        var oneJan1 = new Date(currentdate1.getFullYear(), 0, 1);
        var numberOfDays1 = Math.floor((currentdate1 - oneJan1) / (24 * 60 * 60 * 1000));

        let currentdate1fin = new Date(Date.parse(task_macchina[t1].data_fine));
        var oneJan1fin = new Date(currentdate1fin.getFullYear(), 0, 1);
        var numberOfDays1fin = Math.floor((currentdate1fin - oneJan1fin) / (24 * 60 * 60 * 1000));
        //console.log("Numero giorni iniziale" + numberOfDays1);

        let currentdate2 = new Date(Date.parse(task_macchina[t2].data_inizio));
        var oneJan2 = new Date(currentdate2.getFullYear(), 0, 1);
        var numberOfDays2 = Math.floor((currentdate2 - oneJan2) / (24 * 60 * 60 * 1000));

        let currentdate2fin = new Date(Date.parse(task_macchina[t2].data_fine));
        var oneJan2fin = new Date(currentdate2fin.getFullYear(), 0, 1);
        var numberOfDays2fin = Math.floor((currentdate2fin - oneJan2fin) / (24 * 60 * 60 * 1000));

        var weekNum1_in = Math.ceil((currentdate1.getDay() + 1 + numberOfDays1) / 7);
        var weekNum1_fin = Math.ceil((currentdate1fin.getDay() + 1 + numberOfDays1fin) / 7);
        var weekNum2_in = Math.ceil((currentdate2.getDay() + 1 + numberOfDays2) / 7);
        var weekNum2_fin = Math.ceil((currentdate2fin.getDay() + 1 + numberOfDays2fin) / 7);
        //console.log("Numero settimana iniziale" + weekNum1_in);

        switch (this.zoom) {
            case 25: // Quarto d'ora

                break;
            case HALF_HOUR: // Mezz'ora

                break;
            case HOUR: // Ora

                break;
            case DAY:
                if (task_macchina[t1].data_inizio <= task_macchina[t2].data_inizio && task_macchina[t1].data_fine >= task_macchina[t2].data_inizio ||
                    task_macchina[t1].data_inizio <= task_macchina[t2].data_fine && task_macchina[t1].data_fine >= task_macchina[t2].data_fine) {
                    sovrapposti = true;
                }
                break;
            case WEEK:
                /* console.log("Numero settimane");
                console.log(weekNum1_in);
                console.log(weekNum2_in);
                console.log(weekNum1_fin);
                console.log(weekNum2_fin); */
                if ((weekNum1_in <= weekNum2_in && weekNum1_fin >= weekNum2_fin) || (weekNum1_in >= weekNum2_fin && weekNum1_fin <= weekNum2_in)) {
                    sovrapposti = true;
                }
                break;
            case SHIFT:

                break;
            case MONTH:

                break;
            case YEAR:

                break;
        }
        return sovrapposti;
    }

    // Stabilisce se è possibile collegare due task (task partenza, task arrivo)
    siCollegamento(t1, t2){

        let collegabile = false;
        
        if(t1.id_padre == t2.id_padre && t1.id_task != t2.id_task) {
            collegabile = true;
        }
        
        return collegabile;
    }
}
export default CalendarG;